/**
 * Parts of the catalog card details row: pack size, shipping class, weight, dimensional sum
 * (length + width + height) and volume (length × width × height). Zero / empty values are left out.
 * Pack size is free text set per variation (e.g. "1 piece = 5.5kg") and is shown as-is.
 *
 * `source` is the variation the card shows (see selectProduct in the catalog lists).
 */
function productDetailParts(source, { units = {}, format = (value) => value } = {}) {
    if (!source) return [];

    const number = (value) => Number(value) || 0;
    const weight = number(source.weight);
    const length = number(source.length);
    const width = number(source.width);
    const height = number(source.height);
    const parts = [];
    const packsize = typeof source.packsize === "string" ? source.packsize.trim() : "";

    if (packsize) {
        parts.push({ key: "packsize", text: packsize });
    }
    if (source.shipping_class) {
        parts.push({ key: "shipping", text: source.shipping_class });
    }
    if (weight) {
        parts.push({ key: "weight", text: `${format(weight)}${units.kg ?? "kg"}` });
    }
    if (length + width + height) {
        parts.push({ key: "dimension", text: `${format(length + width + height)}${units.m ?? "m"}` });
    }
    if (length * width * height) {
        parts.push({ key: "volume", text: `${format(length * width * height)}${units.m3 ?? "m³"}` });
    }
    return parts;
}

module.exports = { productDetailParts };
